import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const CroppedEllipseRight: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 133 58" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_2_60"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="133"
        height="58"
      >
        <rect
          x="1"
          y="1"
          width="55.0186"
          height="129.75"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 0.474854 0.622559)"
          fill="#C4C4C4"
          stroke="#FFBCA3"
          strokeWidth="3"
        />
      </mask>
      <g mask="url(#mask0_2_60)">
        <ellipse
          rx="35.4999"
          ry="34.6452"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.9847)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="44.3269"
          ry="43.2597"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.015 91.9844)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="53.9215"
          ry="52.6232"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.9845)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="62.7485"
          ry="61.2377"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.017 91.9846)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="71.5755"
          ry="69.8522"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.017 91.9843)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="81.1701"
          ry="79.2157"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.9843)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="89.9971"
          ry="87.8302"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.9845)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="99.5917"
          ry="97.1938"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.9845)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="108.803"
          ry="106.183"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.9844)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="118.013"
          ry="115.172"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.9843)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="127.224"
          ry="124.161"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.9846)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="136.051"
          ry="132.775"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.6006)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="145.262"
          ry="141.764"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.6006)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="154.473"
          ry="150.753"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.6005)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
        <ellipse
          rx="163.3"
          ry="159.368"
          transform="matrix(4.26589e-08 1 1 -4.47898e-08 105.016 91.6008)"
          stroke="#FFBCA3"
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export { CroppedEllipseRight };
